export function RateBadge({ doc, testid }) {
  if (!doc?.rate_locked || !doc.rate_at_entry) return null;
  return (
    <span data-testid={testid} title="Curs propriu al tranzacției" className="inline-flex items-center text-[10px] font-semibold tabular px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">
      curs {Number(doc.rate_at_entry).toFixed(4)}
    </span>
  );
}
